import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  // Pull the per-inspection transaction/billing report for a date range,
  // optionally limited to a single firm. Returns the rows and also caches
  // them in state for the grid.
  async getTransactions({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getTransactions', () =>
      http.get('billing/transactionReport', {
        params: options
      })
    )
    commit(types.SET_TRANSACTIONS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/billing/actions.js